import React from 'react';
import FileViewer from 'react-file-viewer';

const DocumentViewer = ({ documents }) => {
  const handleFileLoadError = (error) => {
    console.error("Error loading file:", error);
  };

  if (!documents || !Array.isArray(documents) || documents.length === 0) {
    return <div>No documents to display.</div>;
  }

  return (
    <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
      {documents.map((doc, index) => {

        const type = (doc.type || doc.file_extension || "pdf").toLowerCase();
        const url = doc.url || doc.file_path || "";
        const title = doc.title || doc.document_type || "Document";

        const isImage = ["jpg", "jpeg", "png", "webp"].includes(type);

        return (
          <div key={index} style={{ marginBottom: '20px' }}>
            <h3>{title}</h3>

            {isImage ? (
              <img
                src={url}
                alt={title}
                style={{
                  width: '100%',
                  maxHeight: '500px',
                  objectFit: 'contain',
                  borderRadius: '8px'
                }}
              />
            ) : (
              <FileViewer
                fileType={type}
                filePath={url}
                onError={handleFileLoadError}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DocumentViewer;

